import { useLogout } from '@myrentalmate/api-client';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';

import { TwoFactorSetup } from './TwoFactorSetup';

/** Shown instead of the app when two-factor is required and this person hasn't set it up. */
export function TwoFactorRequiredPage() {
  const queryClient = useQueryClient();
  const logout = useLogout({ mutation: { onSettled: () => window.location.assign('/') } });
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2 }}>
      <Paper sx={{ p: 4, maxWidth: 520, width: '100%' }}>
        <Stack spacing={2}>
          <Typography variant="h5">Set Up Two-Factor Sign-In</Typography>
          <Typography color="text.secondary">
            Your organization requires a code from your phone as well as your password. It takes
            about a minute.
          </Typography>
          <TwoFactorSetup onDone={() => void queryClient.invalidateQueries()} />
          <Button variant="text" onClick={() => logout.mutate()}>
            Sign out
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
